<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Funcionando...</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>A documentação do Wails explica como fazer uma aplicação inicial</p>
            <p>
              A partir disto, é só começar a alterar tanto o frontend
              quanto o backend básico que ele gera para fazer o seu sistema.
            </p>
            <p>
              Se houver interesse em aprofundarmos estes tópicos, basta me informar, que eu estou
              disposto a ensinar o mínimo necessário para você começar a sair do chão...
            </p>
            <p>
              Tenho interesse em ajudar aqueles que estiverem interessados em evoluir nestas ferramentas, bem como dar
              consultoria em pontos específicos.
            </p>
            <p>
              <a
                href="mailto:nilo@scobol.com.br?Subject=Consulta"
                target="_top"
              >Qualquer coisa, me mande um email.</a>
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/about">Quem sou eu?</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Firsttest",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
